import useOnBeforeUnload from './hooks/useOnBeforeUnload';
import toastMessageActions from 'jd-library/toastMessageActions';
import { connect } from 'react-redux';

let redirected = false;

const BeforeUnloadHandler = props => {
	useOnBeforeUnload((e) => {
		if(props.imagesBeingUploaded.length){
			props.showToastMessage({
				showToastMessage: true,
				message: 'Please wait Image Upload is in Progress',
				type: 'info',
				duration: 5000
			});
			e.preventDefault();
			e.returnValue = "Please wait Image Upload is in Progress";
		} else if(props.isSourceJustdial && props.redirectToJdExt && !redirected){
			// e.preventDefault();
			// e.returnValue = "Redirecting.....";
			// redirected = true;
			// window.location.replace('https://jdext.php')
		}
	})
	return null;
};

const mapStateToProps = state => {
	return {
		imagesBeingUploaded: state.products.imagesBeingUploaded,
		isAndroidApp: state.library.deviceData.isAndroidApp,
		isSourceJustdial: state.session.isJdSourceAndroid || state.session.isJdSourceIOS,
		redirectToJdExt: state.session.redirectToJdExt,
	};
};

export default connect(mapStateToProps, {
	showToastMessage: toastMessageActions.showMessage
})(BeforeUnloadHandler);
